import React from 'react';
import ProjectEmbed from '../components/ProjectEmbed';

const AimiProject = () => (
    <ProjectEmbed
        title="AIMi Consumer Toy"
        src="/projects/aimi/aimibot-consumer-toy.html"
    />
);

export default AimiProject;
